// extracted by mini-css-extract-plugin
export default {"container":"AppHeaderSearch_container_X3fkW","searchInput":"AppHeaderSearch_searchInput_fxTnz","clearIcon":"AppHeaderSearch_clearIcon_JWJF4"};